<template>
    <div v-if="show">
        <a href="#" :title="deadline.title" @click="toggle()">
            <span :key="deadline.id" class="badge mr-1" :class="badgeClass">
                {{ deadline.day }}
            </span>
        </a>
    </div>
    <div v-else>?</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DateBadge',

    props: ['deadline'],

    data() {
        return {
            initFlag: true,
            localStatus: '',
        }
    },

    created() {
        this.localStatus = this.deadline.status
    },

    methods: {
        async toggle() {
            try {
                // get updated deadline
                const response = await axios.put(
                    `/clientDeadlines/${this.deadline.id}/toggle`
                )
                console.log(response.data.data)
                this.localStatus = response.data.data.status
                await this.$store.dispatch('reportingVM/getCounter', 'all')
                await this.$store.dispatch('reportingVM/getCounter', 'otherTax')
                await this.$store.dispatch(
                    'reportingVM/getCounter',
                    this.activePage
                )
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    },

    computed: {
        badgeClass() {
            return this.localStatus
        },
        ...mapState({
            activePage: (state) => state.browsing.pageName,
            issFilter: (state) => state.browsing.issFilter,
        }),

        show() {
            if (this.activePage === 'iss') {
                return false
            }
            return true
        },
    },
}
</script>

<style scoped></style>
